import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  HostListener,
  inject,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { GROWTHBOOK } from '../../../growthbook';
import { AutoCompleteItem, EmailAutocompleteService } from '../../../services/email-autocomplete.service';
import { AvatarComponent } from '../../../shared/components/avatar/avatar.component';

@Component({
  selector: 'app-autocomplete-results',
  imports: [AvatarComponent, AvatarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './autocomplete-results.component.html',
  styleUrl: './autocomplete-results.component.scss',
})
export class AutocompleteResultsComponent {
  public growthBook = inject(GROWTHBOOK);
  public autocompleteService = inject(EmailAutocompleteService);
  results = input.required<AutoCompleteItem[]>();
  noShadow = input<boolean>();
  noFixed = input<boolean>();
  small = input<boolean>();
  onSelect = output<AutoCompleteItem>();
  onAutoSelectIndex = output<number>();
  autoSelectIndex = signal(0);
  resultsEl = viewChild<ElementRef<HTMLDivElement>>('resultsEl');

  @HostListener('window:keydown', ['$event'])
  keyDownEvent(event: KeyboardEvent) {
    const results = this.results();
    if (event.code === 'ArrowDown' && results.length - 1 > this.autoSelectIndex()) {
      event.preventDefault();
      this.autoSelectIndex.update(v => v + 1);
    } else if (event.code === 'ArrowUp' && this.autoSelectIndex() > 0) {
      event.preventDefault();
      this.autoSelectIndex.update(v => v - 1);
    }
  }

  constructor() {
    effect(() => {
      this.onAutoSelectIndex.emit(this.autoSelectIndex());
    });

    effect(() => {
      const index = this.autoSelectIndex();
      const el = this.resultsEl()?.nativeElement;
      if (!el) return;
      const resultEl = el.querySelector(`.result:nth-child(${index + 1})`);
      if (!resultEl) return;
      resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    effect(() => {
      const results = this.results();
      const index = this.autoSelectIndex();
      if (!results) return;
      if (index > results.length - 1) {
        this.autoSelectIndex.set(results.length - 1);
      }
    });
  }

  loadContactsFromGoogle(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.autocompleteService.loadContactsFromGoogle();
  }

  select(item: AutoCompleteItem, event: Event) {
    this.onSelect.emit(item);
    event.preventDefault();
  }
}
